/**
 * Desktop layout of the Unique Impact section: it renders
 * `../../EnvironmentHealthSafety/JobSafety/JobSafetyDesktop.tsx` (heading, divider, then icon and
 * the two paragraphs side by side) with the same props.
 */
import React from "react";
import JobSafetyDesktop from "../../EnvironmentHealthSafety/JobSafety/JobSafetyDesktop";
import { UniqueImpactProps } from "./UniqueImpact";

/** Renders the Job Safety desktop layout with the Unique Impact copy. */
const UniqueImpactDesktop: React.FC<UniqueImpactProps> = ({ ...props }) => {
	return <JobSafetyDesktop {...props} />;
};

export default UniqueImpactDesktop;
